export default "__VITE_ASSET__COKutN5M__";